import type { TRootState } from 'store';
import type { ITableSelector } from 'interfaces/Table/selector.interface';
import { createTableSelectorSlice } from 'redux/table/helper/createTableSelector.slice';
import {
  itemsPerPageDefault,
  currentPageDefault,
  createdAtSortingDefault,
} from 'redux/table/consts/tableDefaults.consts';

export const ratingsSlice = createTableSelectorSlice(
  'paginatedRatings',
  currentPageDefault,
  itemsPerPageDefault,
  createdAtSortingDefault
);

const { actions, reducer } = ratingsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
  setInitialFiltersSet,
  setMenuColumnList,
} = actions;

export const paginatedRatingsSelector = (state: TRootState): ITableSelector =>
  state.tableRatings;

export default reducer;
